import * as React from 'react'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import H5 from 'web-makeup/dist/H5'
import Radio from 'web-makeup/dist/Radio'
import CloudinaryImage from 'web-makeup/dist/CloudinaryImage'

import { SECONDARY_COLOR } from '../../style'

import SelectedIcon from './../SelectedIcon'
import { BoxHeader, H5SubText } from './../Purchase'

const RadioButton = Radio.Button
const RadioGroup = Radio.Group

const OptionKey = styled.span`
  font-weight: 900;
  font-size: 1rem;
`

const OptionDetails = styled.div`
  padding-left: 1rem;
  padding-top: 1rem;

  @media (min-width: 48rem) {
    flex: 8;
  }

  @media (min-width: 64rem) {
    padding-left: 0;
    text-align: center;

    /* IE11 */
    flex: auto;
    max-width: 100%;

    /* end IE11 */
  }
`

export const Option = styled(RadioButton)`
  &&& {
    border-radius: 6px;
    background-color: white;
    border: solid 1px #bebebe;

    padding: 1rem;

    height: auto;
    color: currentColor;

    flex: 1;

    .ant-radio-button {
      display: none;
    }

    /* Actual content of the button */
    .ant-radio-button + span {
      display: flex;
      justify-content: space-between;
      align-items: center;

      height: 100%;
      filter: grayscale(100%);

      @media (min-width: 64rem) {
        flex-direction: column;
      }
    }

    &&&.ant-radio-button-wrapper-checked {
      border: solid 1px ${SECONDARY_COLOR};

      /* Ant design has !important on .ant-radio-button-wrapper-checked:first-child */

      /* So in order to overwrite it we must have important here */

      /* stylelint-disable-next-line declaration-no-important */
      box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.2) !important;
    }

    .ant-radio-button-checked + span {
      filter: none;
    }

    &.ant-radio-button-wrapper-disabled {
      background: whitesmoke;
    }

    @media (min-width: 48rem) {
      padding: 1rem 1.5rem 0.75rem;
    }
  }
`

const Options = styled(RadioGroup as any)`
  &&& {
    display: flex;
    flex-direction: column;

    @media (min-width: 64rem) {
      flex-direction: row;
    }

    ${Option} + ${Option} {
      margin-top: 1rem;

      @media (min-width: 64rem) {
        margin-top: 0;
        margin-left: 1rem;
      }
    }
  }
`

const SQL_IMAGE_SIZES = {
  mobile: {
    height: 32,
    width: 32,
  },
  tablet: {
    height: 56,
    width: 56,
  },
}

export const BUDGET_LEVELS = [
  {
    amount: 1000,
    title: 'Up to $1,000',
    pic: 'service-quality-levels/icons/90-lite-violet',
  },
  {
    amount: 2500,
    title: 'Up to $2,500',
    pic: 'service-quality-levels/icons/premium-violet',
  },
  {
    amount: 5000,
    title: 'Up to $5,000',
    pic: 'service-quality-levels/icons/90x-violet',
  },
  {
    amount: 10000,
    title: 'Up to $10,000',
    pic: 'service-quality-levels/icons/elite-violet',
  },
  {
    amount: 15000,
    title: '$10,000+',
    pic: 'service-quality-levels/icons/ultra-elite-violet',
  },
]

interface OwnProps {
  value?: number | null
  onChange: (value: string) => void
}

const Budget: React.SFC<OwnProps> = ({ onChange, value }) => (
  <React.Fragment>
    <BoxHeader>
      <H5>
        <FormattedMessage id="purchase.project.budget.title" />
      </H5>
      <H5SubText>
        <FormattedMessage id="purchase.project.budget.description" />
      </H5SubText>
    </BoxHeader>

    <Options defaultValue={value} onChange={event => onChange(event.target.value)}>
      {BUDGET_LEVELS.map(level => (
        <Option value={level.amount} key={level.amount}>
          {BUDGET_LEVELS[0].amount && <SelectedIcon />}
          <CloudinaryImage
            source={{
              type: 'upload',
              id: level.pic,
            }}
            sizes={SQL_IMAGE_SIZES}
            rounded
          />
          <OptionDetails>
            <OptionKey>{level.title}</OptionKey>
          </OptionDetails>
        </Option>
      ))}
    </Options>
  </React.Fragment>
)

export default Budget



// WEBPACK FOOTER //
// ./src/components/Budget/Budget.tsx